import { FaqContent } from "../data";
import close from "../assets/close.png";
import openIcon from "../assets/open.png"; // You may need to add this icon
import React, { useState } from "react";
import SubLayout from "../common/subLayout";

const FaqsComponent = (): JSX.Element => {
  const FaqItem: React.FC<{
    content: string;
    title: string;
  }> = ({ content, title }) => {
    const [open, setOpen] = useState<boolean>(false);

    return (
      <div 
        className={`p-4 border rounded-xl transition-all duration-300 my-4 ${
          open 
            ? 'border-green-500 shadow-md bg-white' 
            : 'border-gray-200 hover:border-gray-300 bg-white'
        }`}
      >
        <div 
          className="flex items-center justify-between cursor-pointer"
          onClick={() => setOpen(!open)}
        >
          <h2 className={`font-medium transition-colors duration-300 ${
            open ? 'text-green-600' : 'text-gray-800'
          }`}>
            {title}
          </h2>
          <span className="flex-shrink-0 ml-4">
            <img
              className={`w-6 h-6 transition-transform duration-300 ${
                open ? 'rotate-45' : 'rotate-0'
              }`}
              src={close}
              alt="toggle accordion"
            />
          </span>
        </div>
        <div 
          className={`overflow-hidden transition-all duration-300 ${
            open ? 'max-h-96 mt-3 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <p className="text-gray-600 leading-relaxed border-t border-gray-100 pt-3">
            {content}
          </p>
        </div>
      </div>
    );
  };

  return (
    <SubLayout 
      text="Frequently Asked Questions" 
      _style="max-w-4xl mx-auto px-4"
    >
      <div className="space-y-2">
        {FaqContent.map((data, index) => (
          <FaqItem key={index} content={data.answer} title={data.question} />
        ))}
      </div>
    </SubLayout>
  );
};

export default FaqsComponent;